export class UserProfile {
  UserId: string;
  UserName: string;
  FirstName: string;
  LastName: string;
  Email: string;
  UserType: string;
  Permissions: any;
  Roles: string[];
}

export class User {
  session_state: any;
  scope: string;
  profile: UserProfile;
  state: any;
  uuid: string;
  scopes: string[];
  myAccountAccessToken?: string;
  myAccountAccessToken_expires_in?: number;
}
